(function(angular){
    'use strict';

    // FIXME: Remove once dependency is removed from core.setup
    angular.module('bluemoon.dms.sidebar', []);

    angular.module('templates-main', []);

    // TODO:
    // Add the 'dms-downgraded' module
    angular.module('onvio.documents', [
        'bluemoon.dms.templates',
        'ui.router',
        'templates-main',
        'pascalprecht.translate',
        'ui.bootstrap',
        'wj',
        'angularFileUpload',
        'bento.modern',
        'bm.webStorage',
        'bluemoon.components',
        'bluemoon.components.i18n',
        'bluemoon.dms.icon',
        'bluemoon.dms.document-services',
        'bluemoon.dms.document-services.models',
        'bluemoon.dms.alerts',
        'bluemoon.dms.alerts.upload',
        'bluemoon.dms.alerts.operation',
        'bluemoon.dms.all-docs-grid',
        'bluemoon.dms.upload',
        'bluemoon.dms.managers',
        'bluemoon.dms.http',
        'bluemoon.dms.models',
        'bluemoon.dms.breadcrumb',
        'bluemoon.dms.nav-breadcrumb',
        'bluemoon.dms.utility',
        'bluemoon.dms.utility.focusInput',
        'bluemoon.dms.utility.routing',
        'bluemoon.dms.toolbar',
        'bluemoon.dms.client-grid',
        'bluemoon.dms.cloud',
        'bluemoon.dms.client-selector',
        'bluemoon.dms.communications',
        'bluemoon.dms.contact-selector',
        'bluemoon.dms.document-grid',
        'bluemoon.dms.storage-grid',
        'bluemoon.dms.grids',
        'bluemoon.dms.recycle-grid',
        'bluemoon.dms.recents-grid',
        'bluemoon.dms.legacy-recents-grid',
        'bluemoon.dms.requests-search-grid',
        'bluemoon.dms.request-template-grid',
        'bluemoon.dms.approvals',
        'bluemoon.dms.approval-search-grid',
        'bluemoon.dms.requests.addEdit',
        'bluemoon.dms.requests.requestTemplate',
        'bluemoon.dms.search-grid',
        'bluemoon.dms.hover',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.i18n',
        'bluemoon.dms.modal.approval',
        'bluemoon.dms.modal.folder-selection',
        'bluemoon.dms.modal.alert-display',
        'bluemoon.dms.modal.alert-display.operation',
        'bluemoon.dms.modal.alert-display.upload',
        'bluemoon.dms.modal.send-items',
        'bluemoon.dms.modal.send-documents',
        'bluemoon.dms.modal.new-request',
        'bluemoon.dms.modal.requestTemplate',
        'bluemoon.dms.validation',
        'bluemoon.dms.viewer',
        'bluemoon.components.httpStatusCodes',
        'bluemoon.components.analytics',
        'bluemoon.dms.search',
        'bluemoon.dms.event-driven-search',
        'bluemoon.dms.request.search',
        'bluemoon.dms.approval.search',
        'bluemoon.dms.utility.cache',
        'bluemoon.dms.column-chooser',
        'bluemoon.dms.userOptions'
    ])

    .config(['dmsNavBreadcrumbConfigProvider', function dmsNavBreadcrumbConfigProviderConfig(navBreadcrumbConfigProvider){
        navBreadcrumbConfigProvider.itemHref = ['$state', '$stateParams', 'treeNavRouteModel', function($state, $stateParams, treeNavRouteModel){

            function generateHrefForItem(item) {
                var itemType = item.container.itemType;

                if (itemType === 'ClientRoot') {
                    return $state.href('TreeView', {
                        drawer: treeNavRouteModel.Client
                    });
                } else if (itemType === 'TemplateRoot') {
                    return $state.href('templateList');
                } else if (itemType === 'Client') {
                    return $state.href('TreeView', {
                        drawerId: item.container.id,
                        drawer: treeNavRouteModel.Client
                    });
                } else if (itemType === 'Project') {
                    if (item.container.primaryAssociationType === 'Client') {
                        return $state.href('TreeViewInContainer', {
                            drawerId: item.container.primaryAssociationId,
                            containerType: treeNavRouteModel.Project,
                            containerId: item.container.id,
                            drawer: treeNavRouteModel.Client
                        });
                    } else if (item.container.primaryAssociationType === 'Firm' &&
                        item.container.primaryAssociationId === 'Templates') {
                        return $state.href('templateRootList', {
                            templateId: item.container.id
                        });
                    }
                } else if (itemType === 'Folder') {
                    if($state.current.name === 'templateFolderList') {
                        return $state.href('templateFolderList', {
                            templateId: $stateParams.templateId,
                            folderId: item.container.id
                        });
                    } else if ($state.current.name === 'projectFolderList') {
                        return $state.href('TreeViewInContainer', {
                            drawerId: $stateParams.clientId,
                            containerType: treeNavRouteModel.Folder,
                            containerId: item.container.id,
                            drawer: treeNavRouteModel.Client
                        });
                    } else if (($state.current.name === 'documentSearchInContainer') &&
                        (item.container && item.container.customFields &&
                        item.container.customFields.clientId)) {
                            return $state.href('TreeViewInContainer', {
                                drawerId: item.container.customFields.clientId,
                                containerType: treeNavRouteModel.Folder,
                                containerId: item.container.id,
                                drawer: treeNavRouteModel.Client
                            });
                    } else if (item.container.root && item.container.root.primaryAssociationType === 'Client') {
                        return $state.href('TreeViewInContainer', {
                            drawerId: item.container.root.primaryAssociationId,
                            containerType: treeNavRouteModel.Folder,
                            containerId: item.container.id,
                            drawer: treeNavRouteModel.Client
                        });
                    } else if (item.container.primaryAssociationType === 'Templates') {
                        return $state.href('templateFolderList', {
                            templateId: item.container.primaryAssociationId,
                            folderId: item.container.id
                        });
                    } else {
                        //TODO: Deprecate
                        return $state.href('folderList', {
                            folderId: item.container.id
                        });
                    }
                } else if (itemType === 'trash') {
                    return $state.href('recycleList');
                } else if (itemType === 'rootList') {
                    return $state.href('allDocsRootList');
                }

                return '';
            }

            return generateHrefForItem;
        }];

        navBreadcrumbConfigProvider.itemClickable = ['$state', function($state){

            function isItemClickable(item, currentContainer) {
                if (['clientStorageList',
                    'folderList',
                    'projectFolderList',
                    'projectRootList',
                    'templateRootList',
                    'templateFolderList'].indexOf($state.current.name) !== -1) {
                    return item.container.id !== currentContainer.id ||
                        item.container.itemType !== currentContainer.type;
                }
                return true;
            }

            return isItemClickable;
        }];
    }])

    // TODO: Remove once new Recents/All Documents tab is completed
    .config(['dmsLegacyRecentsGridConfigProvider', function dmsLegacyRecentsGridConfigProviderConfig(dmsLegacyRecentsGridConfigProvider){

        dmsLegacyRecentsGridConfigProvider.itemHref = ['$state', '$stateParams', 'dmsRouteBuilder', function($state, $stateParams, dmsRouteBuilder){

            function generateHrefForItem(arr){
                var clientId = null;
                var projectId = null;
                var folderId = null;
                var fileId = null;
                var isInTrash = false;

                var immediateParent = {};

                if (!!arr[arr.length - 1].itemType && arr[arr.length - 1].itemType === 'Document'){
                    fileId = arr[arr.length - 1].id;
                    //NOTE: since the array is 1 bigger due to the item, we have to go 2 backwards.
                    immediateParent = {
                        type: arr[arr.length - 2].containerType,
                        id: arr[arr.length - 2].id
                    };
                } else {
                    immediateParent = {
                        type: arr[arr.length - 1].containerType,
                        id: arr[arr.length - 1].id
                    };
                }

                var topParent = {
                    type: arr[0].containerType,
                    id: arr[0].id
                };

                if (!!arr[0] && arr[0].containerType.toLowerCase() === 'projects'){
                    clientId = arr[0].primaryAssociationId;
                    projectId = topParent.id;
                    if (projectId !== immediateParent.id){
                        folderId = immediateParent.id;
                    }
                } else if(!!arr[0] && arr[0].containerType.toLowerCase() === 'folders'){
                    folderId = immediateParent.id;
                } else if (!!arr[0] && arr[0].containerType.toLowerCase() === 'trash'){
                    isInTrash = true;
                }

                return dmsRouteBuilder.buildState(clientId, projectId, folderId, fileId, isInTrash);
            }

            return generateHrefForItem;
        }];
    }]);

}(window.angular));
